import './seals.less'
import { Card, Table } from 'antd'
import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import React from 'react'
import robPermissions from 'constants/robPermissions'
import SealCopyAssistant from './SealCopyAssistant'
import usePermission from 'hooks/usePermission'

const getNestedError = (errors, path) =>
  path.split('.').reduce((acc, key) => acc?.[key], errors)

const Seals = ({
  title,
  rowHeader,
  rowGroups = [],
  columns = [],
  fieldNameBuilder,
  renderCell,
  showCopyAssistant = false,
  copySourceFieldNameBuilder,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()
  const can = usePermission()
  const canEdit = can(robPermissions.EDIT_GENERAL)

  const dataSource = []

  rowGroups.forEach(group => {
    group.rows.forEach((row, rowIndex) => {
      dataSource.push({
        group,
        key: `${group.key}-${row.key}`,
        row,
        rowIndex,
        rowSpan: group.rows.length,
      })
    })
  })

  const tableColumns = [
    {
      key: 'group',
      onCell: record => ({
        rowSpan: record.rowIndex === 0 ? record.rowSpan : 0,
      }),
      render: (_, record) => record.group.label,
      title: rowHeader,
      width: 120,
    },

    ...columns.map(column => ({
      key: column.key,
      render: (_, record) => {
        const fieldName = fieldNameBuilder({
          column,
          group: record.group,
          row: record.row,
        })

        const error = getNestedError(errors, fieldName)

        return (
          <Controller
            control={control}
            name={fieldName}
            render={({ field }) =>
              renderCell({
                column,
                disabled: !canEdit,
                error,
                field,
                fieldName,
                group: record.group,
                row: record.row,
              })
            }
          />
        )
      },
      title: column.label,
      width: 130,
    })),
  ]

  return (
    <div className="seals__wrapper">
      <Card className="seals__card" size="small" title={title}>
        <Table
          bordered
          columns={tableColumns}
          dataSource={dataSource}
          pagination={false}
          rowKey="key"
          scroll={{ x: 'max-content' }}
          t={console.log(JSON.stringify(dataSource, null, 2))}
        />

        {showCopyAssistant && (
          <SealCopyAssistant
            columns={columns}
            copySourceFieldNameBuilder={copySourceFieldNameBuilder}
            fieldNameBuilder={fieldNameBuilder}
            rowGroups={rowGroups}
          />
        )}
      </Card>
    </div>
  )
}

Seals.propTypes = {
  columns: PropTypes.array,
  copySourceFieldNameBuilder: PropTypes.func,
  fieldNameBuilder: PropTypes.func.isRequired,
  renderCell: PropTypes.func.isRequired,
  rowGroups: PropTypes.array,
  rowHeader: PropTypes.string,
  showCopyAssistant: PropTypes.bool,
  title: PropTypes.string,
}

export default Seals
